<template>
  <div class="relative w-full">
    <div class="absolute w-full h-full z-10">
      <div class="sticky top-0 h-screen w-full" ref="el">&nbsp;</div>
    </div>
    <div v-if="works && works.length" class="relative z-10">
      <h2 class="text-center mt-24 text-2xl uppercase tracking-widest">
        Available Works
      </h2>
      <div class="flex flex-wrap px-4 md:px-12 py-8 md:py-16">
        <WorksGridItem
          v-for="work of works"
          :key="work._id"
          :work="work"
          class="w-1/2 lg:w-1/3 px-4 md:px-12 py-4 md:py-12"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, PropType, ref } from 'vue';
import { WorkListing } from '@/types.ts';
import WorksGridItem from '@/components/WorksGridItem.vue';

export default defineComponent({
  components: {
    WorksGridItem,
  },
  emits: ['enter', 'leave'],
  props: {
    works: {
      type: Array as PropType<Array<WorkListing>>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const active = ref(false);
    const el = ref<HTMLElement | null>(null);

    onMounted(() => {
      if (el.value) {
        // const threshold = Array.from(Array(101).keys()).map((i) => i / 100);
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              emit('enter');
            } else {
              emit('leave');
            }
          },
          { threshold: [0.75] }
        );
        observer.observe(el.value);
      }
    });
    return { active, el };
  },
});
</script>
